import { Badge, Inline, t } from '@kanbios/ui';
import { useSession } from '../lib/session';
import { EnvironmentBadge } from './ServerState';

/**
 * Composed business components of the inventory (05-component-hierarchy,
 * « Composants métier composés »): built from DSM parts only.
 */

/** « Atlas Mutuelle › Facturation »: the client › project path of the catalogue. */
export function ClientProjectPath({ client, project }: { client: string; project?: string }) {
  return <>{project ? `${client} › ${project}` : client}</>;
}

/** Regulatory obligations from the qualification (HDS, DORA, sensitive data), « — » when none. */
export function ObligationBadges({ obligations }: { obligations: string[] }) {
  const { enums } = useSession();
  if (obligations.length === 0) return <>{t('inventory.none')}</>;
  return (
    <Inline gap={4} wrap={false}>
      {obligations.map(o => <Badge key={o} tone="neutral" size="sm">{enums.obligations.find(x => x.value === o)?.label ?? o}</Badge>)}
    </Inline>
  );
}

/** D48: the environments of a project or an application, by name, production solid. */
export function EnvironmentBadges({ environments }: { environments: { name: string; type: string }[] }) {
  if (environments.length === 0) return <>{t('inventory.none')}</>;
  return <Inline gap={4} wrap={false}>{environments.map(e => <EnvironmentBadge key={e.name} environment={e.name} type={e.type} />)}</Inline>;
}
